// extracted by mini-css-extract-plugin
export default {"agGridContainer":"deleteCheckboxGroupModal_agGridContainer__2ZF9m"};